import { Component, Injectable, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'loading-overlay',
  templateUrl: 'loading-overlay.component.html',
  standalone: true,
  imports: [MatProgressSpinnerModule]
})
export class LoadingOverlayComponent {
  private data = inject<{Message: string}>(MAT_DIALOG_DATA);

  public Message = this.data.Message;
}

@Injectable()
export class LoadingService {
  private dialog = inject(MatDialog);
  private nextId = 1;

  private refs: LoadingRefInternal[] = [];
  private dialogRef: MatDialogRef<any, any> = null;

  private UpdateDisplay() {
    if (this.refs.length > 0) {
      const message = this.refs[this.refs.length - 1].Message;
      if (this.dialogRef === null) {
        this.dialogRef = this.dialog.open(LoadingOverlayComponent, {
          data: { Message: message },
          disableClose: true
        });
      } else
        if (this.dialogRef.componentInstance) // prevents console log errors when user hits Browser back button
          this.dialogRef.componentInstance.Message = message;
    } else if (this.refs.length === 0 && this.dialogRef !== null) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }

  public StartWaiting(message: string = ""): LoadingRef {
    const resp: LoadingRefInternal = {
      Id: this.nextId++,
      Message: message,
      Stop: () => {
        const toRemove = this.refs.filter(a => a.Id === resp.Id)[0];
        const index = this.refs.indexOf(toRemove);
        if (index >= 0) {
          this.refs.splice(index, 1);
        }

        this.UpdateDisplay();
      }
    };

    this.refs.push(resp);
    this.UpdateDisplay();

    return resp;
  }
}

interface LoadingRef {
  Stop: { (): void };
}

interface LoadingRefInternal extends LoadingRef {
  Id: number;
  Message: string;
}
